import { useState } from "react";
import dataService from "../../../../helpers/dataService";

const useCharts = (url, postData, additionalFetchers = []) => {
  const [isLoading, setIsLoading] = useState(false);
  const [datas, setDatas] = useState(false);
  const [total, setTotal] = useState(0);
  const months = [
    "Jan",
    "Fev",
    "Mar",
    "Avr",
    "Mai",
    "Juin",
    "Juil",
    "Aou",
    "Sep",
    "Oct",
    "Nov",
    "Dec",
  ];

  const lineOptions = {
    colors: ["#00e396", "#feb019", "#008ffb", "#b400e3", "#ff0000", "#ff8c3e"],
    chart: {
      height: 350,
      type: "bar",
      zoom: {
        enabled: false,
      },
    },
    dataLabels: {
      enabled: false,
    },
    tooltip: {
      enabled: true,
      shared: true,
      intersect: false,
    },
    plotOptions: {
      bar: {
        columnWidth: "55%",
      },
    },
    stroke: {
      curve: "smooth",
      width: 2,
    },
    grid: {
      row: {
        colors: ["#f3f3f3", "transparent"], // takes an array which will be repeated on columns
        opacity: 0.5,
      },
    },
    xaxis: {
      categories: months,
    },
  };

  const handleChartData = (datas) => {
    var allTotals = datas.map((o) => o.months.reduce((a, b) => a + b));
    setTotal(allTotals.reduce((a, b) => a + b));
    setDatas({
      line: {
        series: datas.map((o) => ({
          name: o.name,
          data: o.months,
        })),
        options: lineOptions,
      },
    });
  };

  const getDatas = () => {
    setIsLoading(true);

    const mainPromise = new Promise((resolve, reject) => {
      dataService.post(
        `${url}`,
        postData,
        (datas) => resolve(datas),
        (e) => reject(e),
        () => {},
      );
    });

    const additionalPromises = additionalFetchers.map((fetcher) =>
      fetcher(postData)
        .then((res) => res.data)
        .catch(() => []),
    );

    Promise.all([mainPromise, ...additionalPromises])
      .then((results) => {
        const merged = results.flat();
        handleChartData(merged);
      })
      .catch(() => {})
      .finally(() => setIsLoading(false));
  };

  return {
    isLoading,
    getDatas,
    datas,
    total,
  };
};

export default useCharts;
